import { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";
import Administracion from "./views/Administracion";
import GestionUsuarios from "./views/GestionUsuarios";
import RRHH from "./views/RRHH";
import Historial from "./views/Historial";
import Comercial from "./views/Comercial";
import Finanzas from "./views/Finanzas";
import Proyectos from "./views/Proyectos";
import FormularioIngreso from "./views/FormularioIngreso";
import MiPerfil from "./views/MiPerfil";

function App() {
  const location = useLocation();
  const [logueado, setLogueado] = useState(false);
  const [usuarioActivo, setUsuarioActivo] = useState(null);
  const [seccionActiva, setSeccionActiva] = useState("Comercial");
  const [subVistaComercial, setSubVistaComercial] = useState("Ventas");
  const estaEnFormulario = location.pathname.startsWith("/formulario");

  useEffect(() => {
    const datosGuardados = sessionStorage.getItem("usuarioActivo");
    if (datosGuardados) {
      const usuario = JSON.parse(datosGuardados);
      setUsuarioActivo(usuario);
      setLogueado(true);
    }
  }, []);

  const manejarLoginExitoso = (data) => {
    sessionStorage.setItem("usuarioActivo", JSON.stringify(data));
    setUsuarioActivo(data);
    setLogueado(true);
  };

  const cambiarSeccion = (seccion) => {
    setSeccionActiva(seccion);
  };

  const cerrarSesion = () => {
    sessionStorage.removeItem("usuarioActivo");
    setUsuarioActivo(null);
    setLogueado(false);
  };

  const rolUsuario = usuarioActivo?.RolUsuario || "";
  console.log("Rol ORIGINAL desde sesión:", `"${rolUsuario}"`);
  
  // Si la URL es /formulario/:token, renderiza directamente esa vista
  if (location.pathname.startsWith("/formulario/")) {
    return (
      <Routes>
        <Route path="/formulario/:token" element={<FormularioIngreso />} />
      </Routes>
    );
  }

  if (!logueado) {
    return <Login onLogin={manejarLoginExitoso} />;
  }

  return (
    <>
      <Sidebar onSelect={cambiarSeccion} onLogout={cerrarSesion} rolUsuario={rolUsuario}/>

      {/* Navbar superior fija con botón de cerrar sesión */}
      <nav
        className="navbar navbar-light bg-light border-bottom position-fixed top-0 w-100 d-flex justify-content-end px-4"
        style={{ zIndex: 1040, height: "56px", marginLeft: "240px" }}
      >
        <button className="btn btn-outline-danger" onClick={cerrarSesion}>
          Cerrar sesión
        </button>
      </nav>

      {/* Contenido principal, con margen para no quedar bajo la barra superior */}
      <div style={{ marginLeft: "240px", marginTop: "70px", padding: "20px" }}>
        {seccionActiva === "Mi Perfil" && <MiPerfil />}
        {seccionActiva === "Administración" && <Administracion />}
        {seccionActiva === "Gestión de Usuarios" && <GestionUsuarios />}
        {seccionActiva === "RRHH" && <RRHH />}
        {seccionActiva === "Historial" && <Historial />}
        {/* {seccionActiva === "Comercial" && <Comercial />} */}
        {seccionActiva === "Comercial" && (
          <Comercial
            subVistaInicial={subVistaComercial}
            setSubVistaComercial={setSubVistaComercial}
          />
        )}
        {seccionActiva === "Finanzas" && <Finanzas />}
        {seccionActiva === "Proyectos" && <Proyectos />}
      </div>
    </>
  );
}

export default App;
